import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { ICON_CANCEL } from '../extras/icons';
import { Modal, Button, Alert } from 'react-bootstrap';
import { ErrorMessage } from '../extras/toastMessages';
import clienteAxios from '../../config/axios';
import AudienceResume from '../audiences/work/info/AudienceResume';
import { MSG_ERROR_SERVER } from '../../constants/messages';
import Swal from 'sweetalert2';

//Función principal
const AudienceEventModal = props => {
    //Tomo los props
    const { show, handleClose, audienceId } = props;
    //Inicializo el state local
    const [audience,setAudience ] = useState();
    const [loading, setLoading] = useState(false);
    //Cargo al inicio
    useEffect(() =>{
        //Cargo los datos de la audiencia
        fetchAudience();
    },[audienceId]);
    //Función que carga datos de la audiencia
    const fetchAudience = async () =>{
        //Verifico q esteé seteado el ido
        if (audienceId <= 0 || audienceId === null || typeof(audienceId) === 'undefined'){
            //No ejecuto nada
            return false;
        }
        //Consulto datos
        try {
            const response = await clienteAxios.get(`/audiencia/${audienceId}`);
            //Seteo datos
            setAudience(response.data);
            //Oculto la espera
            Swal.close();
        } catch (error) {
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Mensaje de error
            ErrorMessage(data.message);
            
        }
    }
    //Renderizo
    return (
        <Modal 
            show={show} 
            onHide={handleClose} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
            size="lg"
            >
            {
                !loading ? (
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Audiencia { audience ? `#${audience.id}` : '' }
                        </Modal.Title>
                    </Modal.Header>
                ) : null
            }
            <Modal.Body>
                <div className="row">
                    <div className="col-12">
                        {
                            loading ? (
                                'Cargando datos...'
                            ) : null
                        }
                        {
                            audience && !loading ? (
                                <AudienceResume
                                    audience={audience}
                                />
                            ) : (
                                <div>NO HAY AUDIENCIA</div>
                            )
                        }
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                
                <Button variant="secondary" onClick={handleClose}>
                    <ICON_CANCEL /> Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AudienceEventModal;